export default __webpack_public_path__ + "static/media/arrows-diagonals-bltr.c4f7e66e.svg";